/**
 *  页面分享
 *  注: localhost 无法初始化分享成功
 */

/**
 * 默认的常量
 * @type {{des, top: number, left: number, width: number, title: string, url: (*|string), target: string, height: number}}
 */
const defaultConstant = {
  url: `https://${window.location.host}${window.location.pathname}`,
  title: document.title,
  des: getPageDescription(),
  target: 'newwindow',
  width: 800,
  height: 800,
  top: 100,
  left: 100
};

/**
 * 获取页面描述内容
 * @returns {*}
 */
function getPageDescription() {
  const meta = document.getElementsByTagName('meta');
  for (let i in meta) {
    if (typeof meta[i].name !== 'undefined' && meta[i].name.toLowerCase() === 'description') {
      return meta[i].content;
    }
  }
}

/**
 * 分享到QQ空间
 * @param url {string} 设置分享的内容链接
 * @param title {string} 设置分享的标题
 * @param des {string} 设置分享的秒速
 * @param picUrl {string} 设置分享的图片内容
 * @param target {string} 默认: newwindow-新窗口; '_blank'-新页面
 * @param width {number} 设置窗口高度(在newwindow上使用)
 * @param height {number} 设置窗口高度(在newwindow上使用)
 * @param top {number} 设置窗口top(在newwindow上使用)
 * @param left {number} 设置窗口left(在newwindow上使用)
 */
export function shareToQQZone({
  url = defaultConstant.url,
  title = defaultConstant.title,
  picUrl = document.querySelector('base') ? `${document.querySelector('base')?.getAttribute('href')}favicon-200x200.png` : '',
  des = defaultConstant.des,
  target = defaultConstant.target,
  width = defaultConstant.width,
  height = defaultConstant.height,
  top = defaultConstant.top,
  left = defaultConstant.left
}) {
  const shareQQZoneBaseUrl = 'https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey';
  const shareqqzonestring = `${shareQQZoneBaseUrl}?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}&desc=${encodeURIComponent(
    des
  )}&summary=&site=&pics=${encodeURIComponent(picUrl)}`;
  window.open(shareqqzonestring, target, `height=${height},width=${width},top=${top},left=${left}`);
}

/**
 * 分享到微博
 * @param url {string} 设置分享的内容链接
 * @param des {string} 设置分享的描述
 * @param picUrl {string} 设置分享的图片内容
 * @param target {string} 默认: newwindow-新窗口; '_blank'-新页面
 * @param appKey {number} 分享的来源应用appkey, 百度: 1343713053
 * @param width {number} 设置窗口高度(在newwindow上使用)
 * @param height {number} 设置窗口高度(在newwindow上使用)
 * @param top {number} 设置窗口top(在newwindow上使用)
 * @param left {number} 设置窗口left(在newwindow上使用)
 */
export function shareToWeiBo({
  url = defaultConstant.url,
  des = defaultConstant.des,
  picUrl = document.querySelector('base') ? `${document.querySelector('base')?.getAttribute('href')}favicon-200x200.png` : '',
  target = defaultConstant.target,
  appKey,
  width = defaultConstant.width,
  height = defaultConstant.height,
  top = defaultConstant.top,
  left = defaultConstant.left
}) {
  const shareWeiboBase = 'http://service.weibo.com/share/share.php';
  const shareWeiboUrl = `${shareWeiboBase}?url=${encodeURIComponent(url)}&title=${encodeURIComponent(des)}&appkey=${appKey}&pic=${encodeURIComponent(
    picUrl
  )}&searchPic=true#_loginLayer_1556245391157`;
  window.open(shareWeiboUrl, 'newwindow', `height=${height},width=${width},top=${top},left=${left}`);
}

/**
 * 分享到百度贴吧
 * @param url {string} 设置分享的内容链接
 * @param title {string} 设置分享的标题
 * @param picUrl {string} 设置分享的图片内容
 * @param target {string} 默认: newwindow-新窗口; '_blank'-新页面
 * @param width {number} 设置窗口高度(在newwindow上使用)
 * @param height {number} 设置窗口高度(在newwindow上使用)
 * @param top {number} 设置窗口top(在newwindow上使用)
 * @param left {number} 设置窗口left(在newwindow上使用)
 */
export function shareToTieBa({
  url = defaultConstant.url,
  title = defaultConstant.title,
  picUrl,
  target = defaultConstant.target,
  width = defaultConstant.width,
  height = defaultConstant.height,
  top = defaultConstant.top,
  left = defaultConstant.left
}) {
  const shareTieBaBase = 'https://tieba.baidu.com/f/commit/share/openShareApi';
  const shareTieBaUrl = `${shareTieBaBase}?url=${url}&title=${title}&pic=${picUrl}`;
  window.open(shareTieBaUrl, target, `height=${height},width=${width},top=${top},left=${left}`);
}

/**
 * 分享到QQ群/QQ好友
 * @param url {string} 生成分享二维码的连接
 * @param target {string} 默认: newwindow-新窗口; '_blank'-新页面
 * @param width 设置窗口高度(在newwindow上使用)
 * @param height {number} 设置窗口高度(在newwindow上使用)
 * @param top {number} 设置窗口top(在newwindow上使用)
 * @param left {number} 设置窗口left(在newwindow上使用)
 */
export function shareToQQ({
  url = defaultConstant.url,
  target = defaultConstant.target,
  width = defaultConstant.width,
  height = defaultConstant.height,
  top = defaultConstant.top,
  left = defaultConstant.left
}) {
  window.open(
    'https://connect.qq.com/widget/shareqq/index.html?url=' + encodeURIComponent(url),
    target,
    `height=${height},width=${width},top=${top},left=${left}`
  );
}

/**
 * 分享到微信或者朋友圈
 * @param url {string} 生成分享二维码的连接
 * @param target {string} 默认: newwindow-新窗口; '_blank'-新页面
 * @param width 设置窗口高度(在newwindow上使用)
 * @param height {number} 设置窗口高度(在newwindow上使用)
 * @param top {number} 设置窗口top(在newwindow上使用)
 * @param left {number} 设置窗口left(在newwindow上使用)
 */
export function shareToWechat({
  url = defaultConstant.url,
  target = defaultConstant.target,
  width = defaultConstant.width,
  height = defaultConstant.height,
  top = defaultConstant.top,
  left = defaultConstant.left
}) {
  const contentText = '微信扫描二维码，点击右上角 ··· 按钮\n分享到微信好友或微信朋友圈';
  window.open(
    'https://activity.xoyo.com/p/zt/2023/06/29/share-link-to-qr/index.html?url=' + encodeURIComponent(url) + '&content=' + contentText,
    target,
    `height=${height},width=${width},top=${top},left=${left}`
  );
}
